import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import base from './base'
import globalLists from './globalLists'
import devices from './devices'
import numberPools from './numberPools'
import warehouse from './warehouses'
import requests from './requests'
import cucmGroups from './cucmGroups'
import models from './models'
import activeRequest from './activeRequest'
import phoneStatus from './phoneStatus'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    base,
    globalLists,
    devices,
    numberPools,
    requests,
    cucmGroups,
    warehouse,
    models,
    activeRequest,
    phoneStatus
  },
  actions: {
    resetAllStores({ commit }) {
      // Reset all store modules to their initial state
      // Note: We don't reset 'user' module here as it's handled in the logout action
      commit('base/RESET_STATE', null, { root: true })
      commit('globalLists/RESET_STATE', null, { root: true })
      commit('devices/RESET_STATE', null, { root: true })
      commit('numberPools/RESET_STATE', null, { root: true })
      commit('requests/RESET_STATE', null, { root: true })
      commit('cucmGroups/RESET_STATE', null, { root: true })
      commit('warehouse/RESET_STATE', null, { root: true })
      commit('models/RESET_STATE', null, { root: true })
      commit('activeRequest/RESET_STATE', null, { root: true })
    }
  }
})
